import { render, staticRenderFns } from "./RightView.vue?vue&type=template&id=bbb6c552"
import script from "./RightView.vue?vue&type=script&lang=js"
export * from "./RightView.vue?vue&type=script&lang=js"
import style0 from "./RightView.vue?vue&type=style&index=0&id=bbb6c552&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports